import React from 'react';
import PropTypes from 'prop-types';
import { ThemeContext } from 'styled-components';
import {
  ContainerAlt, Title, Description,
  Footer, RightButton, LeftButton, Content, List, Name, Line, Error,
} from './common/styles';
import Check from './common/check';
import OnboardingContext from './common/context';
import { setInvestmentThemes } from '../../services/onboarding-services';

export default function Interests({ previousStep, nextStep }) {
  const { isMobile } = React.useContext(ThemeContext);
  const { state, dispatch } = React.useContext(OnboardingContext);
  const [invalid, setInvalid] = React.useState(false);

  const onToggle = id => {
    setInvalid(false);
    dispatch({ type: 'toggleAssetClassesSelection', payload: id });
  };

  const onNext = e => {
    e && e.preventDefault();
    const ids = state.assetClasses.filter(d => d.selected).map(d => d.id);
    if (!ids.length) {
      setInvalid(true);
      return;
    }
    setInvestmentThemes(ids).then(nextStep);
  };

  return (
    <ContainerAlt>
      <Title>Which investment products do you invest in?</Title>
      <Description>
        Let us know which investment instruments you invest in so we can make
        sure you’re up to date with content published on Livewire which relate
        to your investments.
      </Description>
      <Content>
        <List>
          {state.assetClasses.map(asset => (
            <Line key={asset.id} selected={asset.selected} onClick={() => onToggle(asset.id)} data-role="investment-product">
              <Check checked={asset.selected} />
              <Name>{asset.title}</Name>
            </Line>
          ))}
        </List>
        {invalid && <Error>Please select which investment themes you’re interested in.</Error>}
      </Content>
      <Footer>
        <LeftButton type="button" onClick={previousStep}>
          {isMobile ? 'go back' : 'back'}
        </LeftButton>
        <RightButton type="button" onClick={onNext}>next</RightButton>
      </Footer>
    </ContainerAlt>
  );
}

Interests.propTypes = {
  previousStep: PropTypes.func.isRequired,
  nextStep: PropTypes.func.isRequired,
};
